import { HelpServiceChannel } from '@tableau/search-microview-communication-channels/lib/src/HelpServiceChannel';

import { HelpService } from '~src/commonInfra/services/HelpService';


export function startListening(): () => void {
    const helpServiceChannel = new HelpServiceChannel();

    const stopListeningHelpServiceChannel = helpServiceChannel.listen((request: { category: string }) => {
        return new Promise<string>((resolve, reject) => {
            resolve(HelpService.getServerHelpUrlByCategory(request.category));
        });
    });

    return () => {
        stopListeningHelpServiceChannel();
    };
}